import React, { useRef } from "react";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import AssumptionsMap from 'components/assumptions/AssumptionsMap';
import AssumptionsManager from 'components/assumptions/AssumptionsManager';
import PasteGeosModal from 'components/assumptions/PasteGeosModal';
import CopyShapesModal from 'components/assumptions/CopyShapesModal';
import LoadingSnackbar from 'components/assumptions/LoadingSnackbar';

function Assumptions({ classes }) {
  const gridRef = useRef(null);
  return (
    <div className={classes.container}>
      <AssumptionsManager gridRef={gridRef} />
      <AssumptionsMap gridRef={gridRef} />
      <PasteGeosModal />
      <CopyShapesModal />
      <LoadingSnackbar />
    </div>
  );
}

// == Styles =====================================

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    position: 'relative',
  },
};

export default compose(withRouter, withStyles(styles))(Assumptions);
